<template>
  <div class="vue-app vue-provider-directory">

    <div v-if="status.error" class="callout alert">
      {{ status.error }}
    </div>

    <div v-if="status.ready">

      <div 
        class="grid-x grid-padding-x align-middle" 
        style="padding-bottom:1rem">
        <div 
          v-for="(filter, index) in config.filters"
          :key="index"
          class="cell medium-auto">
          <component 
            :is="filter.component" 
            :filter="filter"
            :value="getFilterValue(filter)"
            @set-filter="setFilter({ key: filter.name, value: $event })">
          </component>
        </div>
      </div>

      <div v-if="result">

        <div v-if="!status.busy">
          <h6 
            v-if="result.total == 0"
            style="font-weight:normal">
            Sorry, your query returned no results.
          </h6>
          <h6 
            v-else
            style="font-weight:normal">
            Your query returned {{ result.total }} provider{{ result.total > 1 ? 's' : '' }}.
          </h6>
        </div>

        <div v-if="result.items" class="provider-list">

          <provider-list 
            :providers="result.items"
            :loading="status.busy"
            @load-more="loadMore">
          </provider-list>

          <div 
            v-if="result.total > 0 && paging.page >= totalPages && !status.busy" 
            class=" text-center">
            <span v-html="$icons.get('line', 'xxlarge')"></span>
            <h6 style="font-weight:normal">No more providers for the current criteria.</h6>
          </div>

        </div>

      </div>

      <div v-if="status.busy" :class="{ 'text-center': result }">
        <loading 
          :label="!result ? 'Getting providers...' : 'Getting more providers...'"
          :center="result !== false">
        </loading>
      </div>
      <div v-else>
        <h6 
          v-if="!result && !selectedFilters"
          style="font-weight:normal">
          Please use the above filters to start your search, or   
          <a @click.prevent="showAll">show all</a> providers.
        </h6>
      </div>

    </div>
  </div>
</template>

<script>
import {_} from 'vue-underscore'
import axios from 'axios'
import DropdownFilter from '@/DropdownFilter.vue'
import TextFilter from '@/TextFilter.vue'
import Loading from '@/Loading.vue'
import ProviderList from '@/ProviderList.vue'

export default {
  name: 'App',
  components: {
    DropdownFilter, Loading, ProviderList, TextFilter
  },
  data () {
    return {
      status: {
        ready: false,
        busy: false,
        error: false
      },
      params: {
        paging: {
          page: 1,
          items_per_page: 24
        },
        filters: {}
      },
      result: false
    }
  },
  methods: {
    init () {
      this.status.ready = true
    },
    showAll () {
      // Remove all filter params
      this.params.filters = {} 
      this.getProviders(true)
    },
    checkForQuery () {
      const uri = window.location.search.substring(1)
      const params = new URLSearchParams(uri)
      const filters = this.params.filters
      if (params) {
        let param_count = 0
        params.forEach((value, key) => {
          if (value.length) {
            let filter = _.find(filters, function(item) {
              return item.url_param == key
            })

            if (filter) {
              param_count++
              let san_val = null
              switch (filter.type) {
                case 'string':
                  san_val = value.replace(/[^\w\s]/gi, '')
                  break
                case 'number':
                  san_val = parseInt(value)
                  break
              }

              if ('options' in filter) {
                san_val = _.find(filter.options, function(option) {
                  return option.id == san_val
                })
              }

              this.setFilter({ key: filter.name, value: san_val })
            }
          }
        })
        if (param_count) {
          this.getProviders()
        }
        
      } else {
        console.log('no params?')
      }
    },
    /** 
     * Load more providers
     */
    loadMore () {
      if (this.totalPages > this.paging.page && !this.status.busy) {
        this.params.paging.page++
        this.getProviders()
      }
    },
    getFilterValue (filter) {
      if (filter.name in this.params.filters) {
        return this.params.filters[filter.name]
      }
      return null
    },
    setFilter (data) {
      let exists = (data.key in this.params.filters)
      if (data.value !== null && data.value != '' && data.value !== undefined) {
        if (exists) {
          this.params.filters[data.key] = data.value
        } else {
          this.$set(this.params.filters, data.key, data.value)
        }
      } else {
        if (exists) {
          this.$delete(this.params.filters, data.key)
        }
      }
      this.getProviders()
    },
    getProviders (reset) {
      
      if (!this.status.busy) {

        if (reset) {
          this.params.paging.page = 1
          this.result = false
        }

        this.status.busy = true
        axios.post(this.config.url + '/providers', {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          },
          params: this.params,
          responseType: 'json'
        }).then(function (response) {
          if (response.data.success) {
            this.result = response.data.result
          } else {
            this.status.error = response.data.message
          }
        }.bind(this)).catch(function (error) {
          this.status.error = error
        }.bind(this)).finally(function () {
          this.status.busy = false
        }.bind(this))
      }
    }
  },
  computed: {
    config () {
      return this.$options.config
    },
    paging () {
      return this.params.paging
    },
    selectedFilters () {
      let data = this.params.filters
      if (Object.keys(data).length) {
        return data
      }
      return false
    },
    totalPages () {
      if (this.result) {
        return Math.ceil(this.result.total / this.paging.items_per_page)
      }
      return 0
    }
  },
  mounted () {
    this.init()
  }
}
</script>
